import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.TRANSFER_ACCOUNT_SET_TRANSFER_ACCOUNT_LIST]: (
    state,
    payload
  ) => {
    state.transferAccountList = payload.transferAccountList

    const sortNumberList = payload.transferAccountList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  }
}

export default Mutations
